module.exports = __webpack_public_path__ + "static/media/opodlogowegrzejnik.3ea994f3.svg";